import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { fetchAddonUsage } from 'api/fetchers/get-addon-usage';
import { CommonMapper } from 'utils/mapper/common.mapper';
import { Feature } from '../../../pb/subscription/v1/addon_pb';

export interface PlanLimitsCountState {
    loading: boolean;
    limits: PlanLimitsCount[] | undefined;
}

export interface PlanLimitsCount {
    id: number;
    name: Feature;
    value: string;
    currentlyUsed: string;
}

const initialState: PlanLimitsCountState = {
    loading: false,
    limits: undefined,
};

export const getPlanLimitsCountThunk = createAsyncThunk<PlanLimitsCount[], void, { rejectValue: string }>(
    'planLimitsCount/get',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchAddonUsage();

            return response.addons.map((addon) => ({
                id: CommonMapper.mapBigintIntoNumber(addon.id),
                name: addon.name,
                value: addon.value,
                currentlyUsed: addon.currentlyUsed,
            }));
        } catch (error: unknown) {
            return rejectWithValue('Error');
        }
    }
);

export const planLimitsCountSlice = createSlice({
    name: 'labelType',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(getPlanLimitsCountThunk.pending, (state: PlanLimitsCountState) => {
            state.loading = true;
        });
        builder.addCase(
            getPlanLimitsCountThunk.fulfilled,
            (state: PlanLimitsCountState, { payload }: PayloadAction<PlanLimitsCount[]>) => {
                state.limits = [...payload];
                state.loading = false;
            }
        );
        builder.addCase(getPlanLimitsCountThunk.rejected, (state: PlanLimitsCountState) => {
            state.loading = false;
        });
    },
    reducers: {},
});

export default planLimitsCountSlice.reducer;
